import React from 'react';
import { WithIcon } from './WithIcon';

export const IconChevronLeft = WithIcon(
  'Chevron Left',
  '0 0 407.436 407.436',
  <polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718" />
);
